export default "__VITE_ASSET__Ds58V8m$__"